import { TCreateOrganizationDTO } from '@/pages/Organizations/organizations.types.ts'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Checkbox from '@/shared/Inputs/Checkbox'

interface IProps {
  organization: TCreateOrganizationDTO
  onChange: (val: any, name: string) => void
}

const OrganizationFormFields = (props: IProps) => {
  return (
    <>
      <FormField label="Наименование" required={true}>
        <TextInput
          value={props.organization.name}
          name="name"
          onChange={props.onChange}
          placeHolder="Введите наименование"
        />
      </FormField>
      <FormField label="ИНН">
        <TextInput value={props.organization.tin} name="tin" onChange={props.onChange} placeHolder="ИНН организации" />
      </FormField>
      <FormField label="Контактное лицо">
        <TextInput
          value={props.organization.contact}
          name="contact"
          onChange={props.onChange}
          placeHolder="ФИО, номер телефона"
        />
      </FormField>
      <Checkbox label="Активна" name="active" onCheck={props.onChange} checked={props.organization.active} />
    </>
  )
}

export default OrganizationFormFields
